import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import logo from "assets/img/slide/logo_white.png";
import Banner from "components/Banner";
import {
  ERROR_GENERAL,
  SUCCESS_PASSWORD_RESET,
  WARNING_INTERNET_EXPLORER,
} from "constants/messages";
import { LOGIN } from "constants/routes";
import { getAuth, RecaptchaVerifier } from "firebase/auth";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router";
import { resetPassword } from "utils/slide/link/accounts";
import AuthCard from "views/Auth/AuthCard";

/* global grecaptcha */

export default function PasswordReset() {
  const { enqueueSnackbar } = useSnackbar();

  const isExplorer = !!document.documentMode;

  const auth = getAuth();

  const [email, setEmail] = useState("");

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (event) => {
    setEmail(event.target.value);
  };

  const renderRecaptcha = () => {
    window.recaptchaVerifier
      .render()
      .then((widgetId) => {
        window.recaptchaWidgetId = widgetId;
      })
      .catch(() => {});
  };

  const resetRecaptcha = () => {
    grecaptcha.reset(window.recaptchaWidgetId);
  };

  useEffect(() => {
    const handleReset = () => {
      setLoading(true);
      const data = {
        email: email,
      };

      resetPassword(data)
        .then((result) => {
          setLoading(false);
          resetRecaptcha();
          if (result.status === "success") {
            enqueueSnackbar(SUCCESS_PASSWORD_RESET, { variant: "success" });
          } else {
            enqueueSnackbar(result.message, { variant: "error" });
          }
        })
        .catch(() => {
          resetRecaptcha();
          setLoading(false);
          enqueueSnackbar(ERROR_GENERAL, { variant: "error" });
        });
    };

    if (submitted) {
      // Fetch-on-mount pattern; React 19 still supports this for initial data loading.
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setSubmitted(false);
      handleReset();
    }

    // eslint-disable-next-line
  }, [enqueueSnackbar, submitted]);

  useEffect(() => {
    window.recaptchaVerifier = new RecaptchaVerifier(auth, "submit-button", {
      size: "invisible",
      badge: "bottomright",
      callback: () => {
        setSubmitted(true);
      },
    });

    renderRecaptcha();
  }, [auth]);

  return (
    <>
      {isExplorer && (
        <Banner message={WARNING_INTERNET_EXPLORER} icon={PriorityHighIcon} />
      )}
      <Container maxWidth="xs">
        <Box sx={{ mt: 8 }}>
          <AuthCard
            header={<img src={logo} alt="Slide" style={{ height: 100 }} />}
          >
            <Typography variant="h4" sx={{ mb: 2 }}>
              Password Reset
            </Typography>
            <Typography variant="subtitle1" sx={{ mb: 2 }}>
              Please enter your email address for a password reset
            </Typography>
            <TextField
              label="Email"
              name="user"
              fullWidth
              value={email}
              onChange={handleChange}
              margin="normal"
              disabled={isExplorer}
            />
            <Grid
              container
              spacing={2}
              sx={{
                alignItems: "center",
              }}
            >
              <Grid size={6}>
                <Link component={RouterLink} to={LOGIN} underline="hover">
                  Back to login
                </Link>
              </Grid>
              <Grid size={6}>
                <Button
                  loading={loading}
                  id="submit-button"
                  fullWidth
                  variant="contained"
                  disabled={isExplorer}
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          </AuthCard>
        </Box>
      </Container>
    </>
  );
}
